import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BehApiRoutes, behClient } from '../beh-api';
import { useNotification } from '../../shared/notification/useNotification';
import {
  IUserWithRightsDtoV2,
  ISetUserRolesRequest,
  IOrgUnitRoleDto
} from '../models/Einstellungen/userRoleDto';

export function useUpdateUserRoles() {
  const queryClient = useQueryClient();
  const { notifyUserFromRequest } = useNotification();

  return useMutation({
    mutationFn: ({
      userId,
      systemRoles,
      orgUnitRoles
    }: {
      userId: string;
      systemRoles: string[];
      orgUnitRoles: IOrgUnitRoleDto[];
    }) =>
      notifyUserFromRequest(
        () =>
          behClient.post<IUserWithRightsDtoV2>(
            BehApiRoutes.setUserRoles(userId),
            { systemRoles, orgUnitRoles } as ISetUserRolesRequest
          ),
        {
          successMessage: 'Rollen erfolgreich aktualisiert',
          errorMessage: 'Rollen konnten nicht aktualisiert werden'
        }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BehApiRoutes.userWithAuthorizations__(0, 10000)]
      });
    }
  });
}
